import {
  RequestCriteria,
  RequestListItem,
  RequestStatus
} from "../../data-access/api-folders/Folder";
import {Injectable} from "@angular/core";
import {Store, StoreConfig} from "@datorama/akita";

export const REQUEST_DEFAULT_PAGE_SIZE: number = 20;

export function createInitialRequestCriteria(): RequestCriteria {
  return {
    term: '',
    statusIndex: null,
    statusIds: [],
    ownerIds: [],
    unassigned: false,
    residenceIds: [],
    stayTypes: [],
    customerTypes: [],
    dateFrom: null,
    dateTo: null,
    page: 0,
    size: REQUEST_DEFAULT_PAGE_SIZE,
  };
}

export interface RequestData {
  /**
   * Page courante de la liste. Attention : la pagination porte sur les **candidats**, puisque le
   * tableau regroupe les demandes par candidat. Ce tableau contient donc toutes les demandes des
   * candidats de la page, soit plus de lignes que la taille de page.
   */
  requests: RequestListItem[];
  /** Statuts de référence, chargés une fois : ils alimentent les facettes et les libellés. */
  requestStatuses: RequestStatus[];
  requestCriteria: RequestCriteria;
  /** Nombre de **candidats** correspondant aux critères, pas de demandes. */
  requestTotalItems: number;
  requestTotalPage: number;
  /** Compteur du menu : demandes dont le statut est en dessous d'un index donné. */
  requestPendingCount: number;
  error?: unknown;
}

export type RequestState = RequestData;

function createInitialState(): RequestState {
  return {
    requests: [],
    requestStatuses: [],
    requestCriteria: createInitialRequestCriteria(),
    requestTotalItems: 0,
    requestTotalPage: 0,
    requestPendingCount: 0,
    error: undefined
  }
}

@Injectable({
  providedIn: 'root'
})
@StoreConfig({
  name: 'request'
})
export class RequestStore extends Store<RequestState> {
  constructor() {
    super(createInitialState());
  }
}
